<template>
<div>
    <Spinner v-if="!loaded" />
    <div class="table-responsive" v-else-if="rows.length > 0">
        <vue-good-table
            :columns="columns"
            :rows="rows"
            :pagination-options="paginationOptions"
            @page-change="onPageChange"
        >
            <template #table-row="props">
                <span v-if="props.column.field === 'status'">
                    <span :class="statusBadgeClass(props.row.status)">
                        {{ props.row.status_display }}
                    </span>
                </span>
                <span v-else-if="props.column.field === 'row_count'">
                    {{ props.row.row_count.toLocaleString() }} rows
                </span>
                <span v-else-if="props.column.field === 'price_paid'">
                    ${{ props.row.price_paid.toFixed(2) }}
                </span>
                <span v-else-if="props.column.field === 'action'">
                    <a
                        v-if="props.row.download_url"
                        :href="props.row.download_url"
                        class="btn btn-sm btn-success"
                        download
                    >
                        <i class="fe fe-download"></i> Download
                    </a>
                    <span v-else-if="props.row.status === 'P' || props.row.status === 'R'" class="text-muted">
                        <i class="fe fe-loader"></i> Generating...
                    </span>
                    <span v-else-if="props.row.status === 'F'" class="text-danger">
                        Failed
                    </span>
                    <span v-else class="text-muted">-</span>
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </div>
    <div v-else class="text-center text-muted py-5">
        <p>No purchases yet.</p>
        <router-link to="/datasets" class="btn btn-primary">
            Browse Datasets
        </router-link>
    </div>
</div>
</template>

<script>
import { toDateTime } from "utils/date";
import Spinner from "../Spinner.vue";
import tablePagination from "../../mixins/tablePagination"

export default {
    components: {
        Spinner,
    },
    mixins: [tablePagination],
    data() {
        return {
            loaded: false,
            pollInterval: null,
            columns: [
                { label: "ID", field: "id", sortable: false },
                { label: "Date", field: "created_at", formatFn: toDateTime, sortable: false },
                { label: "Dataset", field: "title", sortable: false },
                { label: "Status", field: "status", sortable: false },
                { label: "Rows", field: "row_count", sortable: false },
                { label: "Price", field: "price_paid", sortable: false },
                { label: "Action", field: "action", sortable: false },
            ],
            rows: [],
        }
    },
    methods: {
        fetch(data) {
            data = data || {}
            this.$services.Purchases().get(data).then(resp => {
                if (resp.body.state) {
                    this.rows = resp.body.purchases || []
                }
            }).finally(() => {
                this.loaded = true
            })
        },
        onPageChange(params) {
            this.fetch({ page: params.currentPage });
        },
        statusBadgeClass(status) {
            const classes = {
                'P': 'badge bg-warning',
                'R': 'badge bg-info',
                'C': 'badge bg-success',
                'F': 'badge bg-danger'
            }
            return classes[status] || 'badge bg-secondary'
        },
        hasPendingPurchases() {
            return this.rows.some(r => r.status === 'P' || r.status === 'R')
        },
        startPolling() {
            if (this.pollInterval) return
            this.pollInterval = setInterval(() => {
                if (this.hasPendingPurchases()) {
                    this.fetch()
                } else {
                    this.stopPolling()
                }
            }, 5000)
        },
        stopPolling() {
            if (this.pollInterval) {
                clearInterval(this.pollInterval)
                this.pollInterval = null
            }
        }
    },
    created() {
        this.fetch()
    },
    watch: {
        rows() {
            if (this.hasPendingPurchases()) {
                this.startPolling()
            } else {
                this.stopPolling()
            }
        }
    },
    beforeUnmount() {
        this.stopPolling()
    }
}
</script>
